// Checkout confirmation tax-resolution lifecycle.
// Keep in sync with the single-state polling flow in CheckoutView.
export enum TAX_RESOLUTION_PHASE {
    idle = 'idle',
    polling = 'polling',
    resolved = 'resolved',
    failed = 'failed',
}
